import { WhichWeightAPI } from 'WhichWeightAPI';
import { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setWhichWeightCacheExercises } from 'redux/slices/whichWeightCache';

export const useGetExercises = () => {
    
    const dispatch = useDispatch();

    const organizationId = useSelector(state => state.user.organizationId);
    const cachedExercises = useSelector(state => state.whichWeightCache.exercises);
    const cachedExerciseHashMap = useSelector(state => state.whichWeightCache.exerciseHashMap);

    const [exercises, setExercises] = useState(cachedExercises);
    const [exerciseHashMap, setExerciseHashMap] = useState(cachedExerciseHashMap);

    const FetchExercisesFromBackend = useCallback(async () => {
        const jsonBody = {
            organizationId: organizationId
        }

        const result = await WhichWeightAPI("CORE", "GET", "/exercise_directory", jsonBody);

        const exerciseList = result.data.data

        // Create a hash map of the exercises

        const exerciseHashMapFromList = {}
        
        for (let i = 0; i < exerciseList.length; i++) {
            const exercise = exerciseList[i]
            exerciseHashMapFromList[exercise.id] = exercise
        }

        // Store both the list and the hash map in the redux store

        dispatch(
            setWhichWeightCacheExercises({
                exercises: exerciseList,
                exerciseHashMap: exerciseHashMapFromList,
            })
        )

        // Store both the list and the hash map in hooks

        setExercises(exerciseList);
        setExerciseHashMap(exerciseHashMapFromList);
    }, [dispatch]);

    const refetch = useCallback(async () => {
        await FetchExercisesFromBackend();
    }, [FetchExercisesFromBackend]);

    useEffect(() => {
        if (organizationId === null) return;

        if (cachedExercises.length === 0) {
            FetchExercisesFromBackend();
        }

        // Make sure any changes to the redux store directly get updated
        if (cachedExercises !== null) {
            setExercises(cachedExercises);
            setExerciseHashMap(cachedExerciseHashMap);
        }
    }, [cachedExercises, cachedExerciseHashMap, FetchExercisesFromBackend]);

    return { exercises, exerciseHashMap, refetch };
};
